import React from 'react';

const WHATSAPP_PHONE = '557131766882'; // número em formato internacional sem +
const WHATSAPP_MESSAGE = 'Olá! Vim do portal do cliente e gostaria de mais informações sobre o meu pedido.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function WhatsAppButton() {
  return (
    <a
      className="whatsapp-float-button"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Fale conosco pelo WhatsApp"
    >
      <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.81 11.81 0 0012 0C5.37 0 0 5.37 0 12a11.7 11.7 0 001.64 6.15L0 24l5.97-1.57A11.91 11.91 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.22-3.48-8.52zM12 22.02c-1.7 0-3.36-.44-4.82-1.27l-.34-.2-3.54.93.95-3.45-.22-.35A9.58 9.58 0 012.44 12C2.44 6.53 6.53 2.44 12 2.44c2.55 0 4.95.99 6.75 2.79A9.55 9.55 0 0121.56 12 9.57 9.57 0 0112 22.02zm5.37-7.3c-.29-.15-1.73-.86-2-.96-.27-.1-.46-.15-.66.15-.2.29-.77.96-.94 1.16-.17.2-.35.22-.64.07-.29-.15-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.12.29-.35.44-.52.15-.17.2-.29.29-.48.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.2-.24-.58-.48-.5-.66-.51-.17-.01-.37-.01-.57-.01s-.52.08-.79.37c-.27.29-1.04 1.02-1.04 2.48s1.06 2.87 1.2 3.06c.15.2 2.08 3.25 5.05 4.56.71.31 1.26.5 1.69.64.71.24 1.36.2 1.87.12.57-.09 1.73-.71 1.98-1.4.25-.68.25-1.27.17-1.4-.08-.13-.29-.2-.6-.35z"/>
      </svg>
    </a>
  );
}

export default WhatsAppButton;
